import type { AddAvatarStep } from './AddPhotoDialog';
import { CropAvatar } from './Steps/CropAvatar';
import { UploadPreviewStep } from './Steps/UploadPreviewStep';
import { UploadingStep } from './Steps/UploadingStep';
import type { ValidationError, SystemError } from './validateImage';

interface Props {
  currentStep: AddAvatarStep;
  setCurrentStep: (step: AddAvatarStep) => void;
  openDialog: () => void;
  closeDialog: () => void;
  croppedImage: File | null;
  setCroppedImage: (file: File | null) => void;
  setValidationError: (value: ValidationError | SystemError | false) => void;
  originalFile: File | null;
  setOriginalFile: (file: File | null) => void;
  onUploadStepEnd: () => void;
  hasError: React.MutableRefObject<boolean>;
}

export const AddPhotoFlow = ({
  currentStep,
  setCurrentStep,
  openDialog,
  closeDialog,
  croppedImage,
  setCroppedImage,
  setValidationError,
  originalFile,
  setOriginalFile,
  onUploadStepEnd,
  hasError,
}: Props) => {
  const navigateToCropStep = () => setCurrentStep('Crop');
  const navigateToUploadPreviewStep = () => setCurrentStep('UploadPreview');
  const navigateToUploadingStep = () => setCurrentStep('Uploading');

  const backToCropWithOriginal = () => {
    navigateToCropStep();
  };

  switch (currentStep) {
    case 'Crop':
      return (
        <CropAvatar
          originalFile={originalFile}
          setOriginalFile={setOriginalFile}
          setCroppedImage={setCroppedImage}
          navigateToUploadPreviewStep={navigateToUploadPreviewStep}
          navigateToCropStep={navigateToCropStep}
          openDialog={openDialog}
          setValidationError={setValidationError}
        />
      );
    case 'UploadPreview':
      return (
        <UploadPreviewStep
          backToCropStep={backToCropWithOriginal}
          navigateToUploadingStep={navigateToUploadingStep}
          croppedImage={croppedImage}
        />
      );
    case 'Uploading':
      return (
        <UploadingStep
          closeDialog={closeDialog}
          croppedImage={croppedImage}
          onUploadStepEnd={onUploadStepEnd}
          hasError={hasError}
        />
      );
    default:
      // eslint-disable-next-line no-console
      console.error('Invalid step', currentStep);
      return null;
  }
};
